import { AxiosRequestConfig } from 'axios'
import { useState } from 'react'

import { BackendPaginatedConfig, useBackendPaginatedQuery } from '../useBackendPaginatedQuery'

export interface UseStoreSearchProps {
  debounce?: number
  defaultSearchValue?: string
  page?: number
  limit?: number
  state?: string
  humpClubIds?: string
  includeUnpublished?: boolean
  locationSearch?: boolean
  lat?: number
  lng?: number
}

export function useStoreSearch<Store>({
  debounce = 500,
  defaultSearchValue = '',
  page = 1,
  limit = 10,
  state,
  humpClubIds,
  includeUnpublished = false,
  locationSearch = true,
  lat,
  lng,
}: UseStoreSearchProps = {}) {
  const [searchValue, setSearchValue] = useState(defaultSearchValue)

  const params: AxiosRequestConfig['params'] = {
    query: searchValue,
    page,
    limit,
    state,
    humpClubIds,
    includeUnpublished,
    lat,
    lng,
    locationSearch,
  }

  const config: BackendPaginatedConfig<Store> = {
    debounce,
    enabled: searchValue !== '' || (lat && lng),
  }
  const query = useBackendPaginatedQuery<Store>(['stores', { params }], config)

  return {
    ...query,
    searchValue,
    setSearchValue,
  }
}

export default useStoreSearch
